import { render, staticRenderFns } from "./vistaRectificaciones.vue?vue&type=template&id=6026dc6d&scoped=true"
import script from "./vistaRectificaciones.vue?vue&type=script&lang=js"
export * from "./vistaRectificaciones.vue?vue&type=script&lang=js"
import style0 from "./vistaRectificaciones.vue?vue&type=style&index=0&id=6026dc6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6026dc6d",
  null
  
)

export default component.exports